import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { Col, Container, Row } from "react-bootstrap";
import CheckoutDetails from "../../../components/checkoutDetails/CheckoutDetails";
import PaymentMethods from "../../../components/PaymentMethods";
import GooglePay from "../../../components/googlePay/GooglePay";
import { UUIDContext } from "../../../UUIDContexted";
import CONSTANTS from "../../../utils/constants";

const GooglePayPage: React.FC = () => {
    const pblData = useContext(UUIDContext);

    return (
        <Container fluid className="d-flex payment-method" data-testid="parentContainer">
            <Row className="w-100 mobile-column-reverse g-0">
                <Col xs={12} lg={6} className="paymentMethods-wrapper" data-testid="info-paymentmethods">
                    <PaymentMethods choosenMethod={'googlePay'} />
                    <GooglePay />
                </Col>

                <Col className="d-none d-lg-block" style={{ flex: 1 }}></Col> {/* Spacer div for in-between column */}

                <Col xs={12} lg={5} id="checkout-details" className="checkout-details flex-column" data-testid="info-checkoutDetails">
                    <div className="mobile-page-heading d-block d-lg-none">
                        <span>
                            <span className="mobile-page-heading-span3">
                                <FormattedMessage
                                    id={CONSTANTS.PAYMENT_METHODS.PAGE_HEADING}
                                    defaultMessage="Payment-link"
                                />
                                <br />
                            </span>
                            <span className="mobile-page-heading-span4">
                                <FormattedMessage
                                    id={CONSTANTS.PAYMENT_METHODS.SUB_PAGE_HEADING}
                                    defaultMessage="Checkout"
                                />
                            </span>
                        </span>
                    </div>
                    {pblData && pblData.items && pblData.amountOfMoney ?
                        <CheckoutDetails CheckoutDetailsData={{ items: pblData.items, amountOfMoney: pblData.amountOfMoney }} />
                        : <div><b><FormattedMessage id={CONSTANTS.NO_DATA_AVAILABLE} defaultMessage="No Data Available" /></b></div>
                    }
                </Col>
            </Row>
        </Container>
    );
}

export default GooglePayPage;